import * as Types from '@/types/productivity-schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql-productivity';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type PMyFunctionalPermissionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PMyFunctionalPermissionsQuery = { myFunctionalPermissions?: Array<string | null> | null };


export const PMyFunctionalPermissionsDocument = /*#__PURE__*/ gql`
    query pMyFunctionalPermissions {
  myFunctionalPermissions
}
    `;

export function usePMyFunctionalPermissionsQuery(options?: Omit<Urql.UseQueryArgs<PMyFunctionalPermissionsQueryVariables>, 'query'>) {
  return Urql.useQuery<PMyFunctionalPermissionsQuery, PMyFunctionalPermissionsQueryVariables>({ query: PMyFunctionalPermissionsDocument, ...options });
};